/* eslint-disable import/first,no-func-assign */
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from 'react';

var SvgSecurityBots = props => /*#__PURE__*/React.createElement("svg", _extends({}, props, {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 64 64",
  "aria-hidden": !props['aria-label'],
  focusable: "false"
}), /*#__PURE__*/React.createElement("path", {
  d: "M53.984 21.15H34v-5.78a4 4 0 1 0-4 0v5.78H10.016l-2 2v30.776l2 2h43.968l2-2V23.15l-2-2Zm-2 30.776H12.016V25.15h39.968v26.775Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M22.677 38.058a3.325 3.325 0 0 0 3.321-3.328 3.325 3.325 0 0 0-3.321-3.328 3.325 3.325 0 0 0-3.321 3.328 3.325 3.325 0 0 0 3.321 3.328Zm18.646 0a3.325 3.325 0 0 0 3.321-3.328 3.325 3.325 0 0 0-3.321-3.328 3.325 3.325 0 0 0-3.321 3.328 3.325 3.325 0 0 0 3.321 3.328Zm-3 4.274H25.678v4h12.645v-4Z"
}));

export default SvgSecurityBots;